// imports
import Overlay from 'minsky-kit/js/components/Overlay';
import { strToCssClass } from 'minsky-kit/js/utils/css';

// private statics

// class definition
export default class WOverlay extends Overlay {
    // constructor
    constructor (args = {}, objectName = 'WOverlay') {
        args.debug = args.debug || false;

        const originalObjectName = objectName;
        objectName = 'Overlay';

        // super
        super(args, objectName);

        // class management
        this.$el.classList.add(strToCssClass(objectName, null, originalObjectName.replace('Overlay', '')));
    }

    // methods
    destroy () {
        super.destroy();
    }

    // getters & setters
}

// Utils

// Event handlers
